<template>
  <div id="box-campaign-posts">
    <div class="modal fade" :id="modalId">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">

          <!-- Popup header -->
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">&times;</span>
              <span class="sr-only">Close</span>
            </button>
            <h4 class="modal-title" id="myModalLabel">
              Posts for campaign {{ campaign.name }}
            </h4>
          </div>

          <!-- Popup content -->
          <div class="modal-body">
            <div class="row" v-if="buttonShow('create')">
              <div class="col-xs-3">
                <label>Description</label>
                <input type="text" class="form-control" placeholder="Description" v-model="newPost.description">
              </div>
              <div class="col-xs-2">
                <label>Location</label>
                <input type="text" class="form-control" placeholder="Location" v-model="newPost.location">
              </div>
              <div class="col-xs-2">
                <label>Hashtags</label>
                <input type="text" class="form-control" placeholder="Hashtags" v-model="newPost.hashtag">
              </div>
              <div class="col-xs-2">
                <label>Image</label>
                <input type="file" class="form-control-file" id="newPostImage" ref="newPostImage">
              </div>
              <div class="col-xs-2" style="padding-top:22px">
                <b-button variant="primary" class="col-xs-12" @click.stop="createPost()">
                  Create
                </b-button>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <b-table striped bordered hover responsive :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="items" :fields="fields">
                  <template slot="imageURL" slot-scope="row">
                    <template v-if="row.item.imageURL">
                      <img :src="row.item.imageURL" alt="image" style="max-height:80px;max-width:500px">
                    </template>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <!-- "Accept" button -->
                    <button type="button" class="btn btn-success btn-sm" v-if="acceptButtonShow(row.item.status)" @click="approvePost(row.item)">
                      <i class="fa fa-check"></i>
                    </button>
                    <button type="button" class="btn btn-default btn-sm" v-if="canEditPost(row.item)" @click="showModalEditPost(row.item)" data-toggle="modal" data-target="#modal-edit-post">
                      Edit
                    </button>

                    <!-- "Reject" button -->
                    <button type="button" class="btn btn-danger btn-sm" v-if="rejectButtonShow(row.item.status)" @click="rejectPost(row.item)">
                      <i class="fa fa-times"></i>
                    </button>

                    <input type="text" class="form-control input-instagram" v-if="showInputUpdateInstagram == row.item.id" v-model="instagramURL">

                    <button type="button" class="btn btn-primary btn-sm" v-if="updateInstagramURLShow(row.item.status)" @click="showModalUpdateInstagramURL(row.item)">
                      Update Instagram URL
                    </button>
                    <button type="button" class="btn btn-danger btn-sm" v-if="showInputUpdateInstagram == row.item.id" @click.prevent="showInputUpdateInstagram = ''">
                      <i class="fa fa-times"></i>
                    </button>
                  </template>
                </b-table>
              </div>
            </div>
            <!-- Pagination -->
            <div class="row">
              <div class="col-xs-12">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" size="sm" align="center" />
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal" ref="closeButton">Close</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" tabindex="-1" role="dialog" id="modal-edit-post">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Modal title</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Description</label>
              <input type="text" class="form-control" placeholder="Description" v-model="currentPost.description">
            </div>
            <div class="form-group">
              <label>location</label>
              <input type="text" class="form-control" placeholder="Description" v-model="currentPost.location">
            </div>
            <div class="form-group">
              <label>Hashtags</label>
              <input type="text" class="form-control" placeholder="Description" v-model="currentPost.hashtag">
            </div>
            <div class="form-group">
              <label>Image</label>
              <input type="file" class="form-control-file" id="editPostImage" ref="editPostImage">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal" ref="btnCloseEditPostModal">Cancel</button>
            <button type="button" class="btn btn-primary" @click.prevent="editPost()">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import campaignAPIs from './campaignAPIs'
import config from '@/config'
import campaignConfig from './config'

export default {
  name: 'ViewPostModal',
  props: ['modalId', 'campaignData'],
  data() {
    return {
      newPost: {},
      campaign: {},
      sortBy: 'name',
      sortDesc: false,
      fields: [
        { key: 'statusDisplay', label: 'Status', sortable: true },
        { key: 'description', sortable: true },
        { key: 'location', sortable: true },
        { key: 'hashtag', sortable: true },
        { key: 'imageURL', label: 'Image', sortable: true },
        { key: 'instagramURL', label: 'Instagram Url', sortable: true },
        { key: 'actions', sortable: false }
      ],
      items: [],
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      showInputUpdateInstagram: '',
      instagramURL: '',
      currentPost: {}
    }
  },
  watch: {
    campaignData: function(newCampaignData) {
      this.campaign = newCampaignData

      // Refresh list
      this.refreshPostList()
    }
  },
  computed: {
    currentUserRole: function() {
      return Number(this.$store.state.user.role)
    }
  },
  methods: {
    buttonShow(type) {
      const buttonPermission = config['userPermissions']['post'][type]

      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole)
      } else if (typeof buttonPermission === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.campaignStatus.includes(this.campaignStatus)
      }

      return false
    },
    acceptButtonShow: function(postStatus) {
      const rules = {
        [campaignConfig.postStatus.DRAFT]: [config.userRoles.INFLUENCER],
        [campaignConfig.postStatus.AD_STRATEGIST_PENDING]: [config.userRoles.AD_STRATEGIST],
        [campaignConfig.postStatus.AD_STRATEGIST_REJECT]: [config.userRoles.INFLUENCER],
        [campaignConfig.postStatus.CLIENT_PENDING]: [config.userRoles.CLIENT],
        [campaignConfig.postStatus.CLIENT_REJECT]: [config.userRoles.AD_STRATEGIST],
        [campaignConfig.postStatus.CLIENT_APPROVE]: [config.userRoles.INFLUENCER],
        [campaignConfig.postStatus.LIVE]: []
      }
      return rules[postStatus].includes(this.currentUserRole)
    },
    rejectButtonShow: function(postStatus) {
      const rules = {
        [campaignConfig.postStatus.DRAFT]: [],
        [campaignConfig.postStatus.AD_STRATEGIST_PENDING]: [config.userRoles.AD_STRATEGIST],
        [campaignConfig.postStatus.AD_STRATEGIST_REJECT]: [],
        [campaignConfig.postStatus.CLIENT_PENDING]: [config.userRoles.CLIENT],
        [campaignConfig.postStatus.CLIENT_REJECT]: [config.userRoles.AD_STRATEGIST],
        [campaignConfig.postStatus.CLIENT_APPROVE]: [],
        [campaignConfig.postStatus.LIVE]: []
      }
      return rules[postStatus].includes(this.currentUserRole)
    },
    updateInstagramURLShow(postStatus) {
      return postStatus === campaignConfig.postStatus.LIVE
    },
    createPost() {
      const form = new FormData()

      form.append('description', this.newPost.description)
      form.append('location', this.newPost.location)
      form.append('hashtag', this.newPost.hashtag)

      if (this.$refs.newPostImage.files.length > 0) {
        form.append('photo', this.$refs.newPostImage.files[0])
      }

      campaignAPIs
        .createPost(this.campaign.id, form)
        .then(response => {
          // Update post list table
          this.refreshPostList()
          this.newPost = {}
          this.$refs.newPostImage.value = ''
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    approvePost(post) {
      campaignAPIs
        .approvePost(post.id, post.status)
        .then(response => {
          // Refresh post list
          this.refreshPostList()
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    rejectPost(post) {
      campaignAPIs
        .rejectPost(post.id, post.status)
        .then(response => {
          // Refresh post list
          this.refreshPostList()
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    showModalUpdateInstagramURL(post) {
      if (this.showInputUpdateInstagram !== post.id) {
        this.instagramURL = post.instagramURL
        this.showInputUpdateInstagram = post.id
      } else {
        campaignAPIs
          .updatePost(this.campaign.id, post.id, this.instagramURL)
          .then(response => {
            this.showInputUpdateInstagram = ''
            this.instagramURL = ''
            this.refreshPostList()
          })
          .catch(error => {
            console.log('error', error)
          })
      }
    },
    refreshPostList: function() {
      campaignAPIs
        .getPosts(this.campaign.id)
        .then(response => {
          // Update post list table
          const newItems = response.map(post => {
            post.statusDisplay = campaignConfig.postStatusDisplay[post.status]

            return post
          })

          this.items = newItems
          this.totalRows = this.items.length
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    showModalEditPost(post) {
      this.currentPost = Object.assign({}, post)
    },
    editPost() {
      const form = new FormData()

      form.append('description', this.currentPost.description)
      form.append('location', this.currentPost.location)
      form.append('hashtag', this.currentPost.hashtag)

      if (this.$refs.editPostImage.files.length > 0) {
        form.append('photo', this.$refs.editPostImage.files[0])
      }

      campaignAPIs
        .editPost(this.campaign.id, this.currentPost.id, form)
        .then(response => {
          this.refreshPostList()
          this.currentPost = {}
          this.$refs.editPostImage.value = ''
          this.$refs.btnCloseEditPostModal.click()
        })
        .catch(error => {
          this.$refs.btnCloseEditPostModal.click()
          console.log('error', error)
        })
    },
    canEditPost(post) {
      return campaignConfig.postStatus.AD_STRATEGIST_REJECT === post.status
    }
  }
}
</script>

<style>
.input-instagram {
  width: 200px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// ViewPostModal.vue?6b3b8ef0